import React from "react"

import { Image } from "primereact/image"
import QR from "../../assets/qr.jpeg"
import termsPDF from "../login/components/Terms.pdf"

function ContactUs() {
  return (
    <div className="flex flex-column align-items-center justify-content-center gap-2">
      <h2 className="text-white text-2xl font-semibold ">Contáctenos:</h2>
      <Image src={QR} alt="QR" width="200" height="200" />
      <div className="flex align-items-center mt-2 gap-2">
        <i className="pi pi-whatsapp text-white text-base my-0"></i>
        <a
          href="https://wa.link/xhl0bf"
          target="_blank"
          rel="noopener noreferrer"
          className="text-white text-center text-base my-0"
        >
          +506 6057-7163
        </a>{" "}
      </div>
      <div className="flex align-items-center mt-2 gap-2">
        <i className="pi pi-link text-white text-base my-0"></i>
        <a
          href="https://www.agenciamdtours.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-white text-center text-base my-0"
        >
          Agencia MD Tours
        </a>
      </div>

      <div className="flex align-items-center mt-2 gap-2">
        <i className="pi pi-facebook text-white text-base my-0"></i>
        <a
          href="https://es-la.facebook.com/agenciamdtours/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-white text-center text-base my-0"
        >
          Facebook
        </a>
      </div>

      <div className="flex align-items-center mt-2 gap-2">
        <i className="pi pi-instagram text-white text-base my-0"></i>
        <a
          href="https://www.instagram.com/agencia__mdtours/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-white text-center text-base my-0"
        >
          Instagram
        </a>
      </div>

      <div className="flex align-items-center mt-2 gap-2">
        <i className="pi pi-youtube text-white text-base my-0"></i>
        <a
          href="https://www.youtube.com/channel/UCducE9TqnkfD-9-C49IfuWA"
          target="_blank"
          rel="noopener noreferrer"
          className="text-white text-center text-base my-0"
        >
          YouTube
        </a>
      </div>

      <div className="flex align-items-center mt-2 gap-2">
        <i className="pi pi-tiktok text-white text-base my-0"></i>
        <a
          href="https://www.tiktok.com/@agenciamdtours?_t=ZM-8wIeUBYaGRS&_r=1"
          target="_blank"
          rel="noopener noreferrer"
          className="text-white text-center text-base my-0"
        >
          TikTok
        </a>
      </div>

      <a
        href={termsPDF}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-2 text-sm  cursor-pointer font-bold"
        style={{
          color: "var(--secondary-color)",
          textDecoration: "underline",
        }}
      >
        Términos y Condiciones
      </a>
    </div>
  )
}

export default ContactUs
